import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { commodityTypes } from './actionTypes';
import {
    getCommodityListSuccess,
    getCommodityListFail,
    getCommodityListByGUIDSuccess,
    getCommodityListByGUIDFail,
    getMilestoneConfigCommoditySuccess,
    getMilestoneConfigCommodityFail,
    getPackingListCommoditySuccess,
    getPackingListCommodityFail,
} from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const fetchCommodity = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetComodityList(Comodity: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to || ''}",
      order : "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        comodityData{
          CRclientId
        CRCreatedOn
        CRReleaseDate
        CRNumber
        CRCreatedByName
        CRVersion
        CRIssuedByName
        CRCreatorNetworkID
        CRTotalPieces
        CRTotalWeight
        CRTotalVolume
        CRTotalVolumeWeight
        CRTotalValue
        CRReleasedToName
        CRStatus
        CRHasAttachments
        CRIsOnline
        CRIsLiquidated
        CRCFaverage_days_to_prepare
        CRCFaverage_days_to_release
        CRCFwh_location
        CRCFcr_cartons
        CRCFcr_pallets
        CRGUID      
        CRBillingClientName
        CRBillingClientGUID
        CRReleasedToGUID
        CRcustomFields {
          name
          value
          internalName
        } 
        PONumber
        POCreatedOn
        POCreatedByName
        POVersion
        POStatus
        POBuyerName
        POSellerName
        POTotalAmountInCurrency
        POItemsAmountInCurrency
        POChargesAmountInCurrency
        POTaxAmountInCurrency
        POTotalAmount
        POItemsAmount
        POChargesAmount
        POTaxAmount
        POTotalWeight
        POTotalVolume
        POTotalTradeDiscount
        POTotalTradeDiscountInCurrency
        POExchangeRate
        POCreatorNetworkID
        POTotalPieces
        POIsAcceptedBySeller
        POIsOnline
        POIsCancelled

        POGUID
        POCFstatus_gwae
        POCFbrand
        POCFcommodity_type
        POcreatedAt
        POupdatedAt
        POBillingClientName
        POBillingClientGUID
        POBuyerGUID
        POSellerGUID
        POApprovedByName
        PODocumentTemplateName
        PONotes
        POPaymentTerms
        POReferenceNumber
        POIsOnlineTransaction    
        POIsTrackingEmailSent          
        POLastLineID
        POLengthPrecision    
        POLengthUnit    
        POVolumePrecision      
        POVolumeUnit      
        POVolumeWeightPrecision        
        POWeightPrecision    
        POWeightUnit
        POJOBNumber
        POcustomFields {
          name
          value
          internalName
        } 
        WRclientId
        WRCreatedOn
        WRNumber
        WRCreatedByName
        WRVersion
        WRModeOfTransportCode
        WRIssuedByName
        WRShipperName
        WRConsigneeName
        WRCreatorNetworkID
        WRTotalPieces
        WRTotalWeight
        WRTotalVolume
        WRTotalVolumeWeight
        WRChargeableWeight
        WRTotalValue
        WRStatus
        WRHasAttachments
        WRLastItemID
        WRIsOnline
        WRIsLiquidated
        WRGUID
        WRCFstatus_gwae
        WRCFwh_location
        WRcreatedAt
        WRupdatedAt
        WRBillingClientName
        WRBillingClientGUID
        WRDestinationAgentName
        WRcustomFields {
          name
          value
          internalName
        } 
        clientId
        CLVersion
        CLStatus
        CLWarehouseReceiptGUID
        CLCargoReleaseGUID
        CLPackageName
        CLLocationCode
        CLWarehouseReceiptNumber
        CLCargoReleaseNumber
        CLOutDate
        CLPieces
        CLPieceQuantity
        CLWHRItemID
        CLOrderIndex
        CLContainedPiecesWeightIncluded
        CLIsContainer
        CLIsSummarized
        CLIncludeInSED
        CLIsPallet
        CLIsOverstock
        CLNotLoaded
        CLInTask
        CLDescription
        CLPartNumber
        CLUpItemGUID
        CLOutShipmentGUID
        CLOutMasterWayBillNumber
        CLOutHouseWayBillNumber
        CLLastReceptionNetworkID
        CLShipmentType
        CLSupplierPONumber
        CLPurchaseOrderGUID
        CLSalesOrderGUID
        CLSOLineID
        CLSalesOrderNumber
        CLEntryDate
        CLExpirationDate
        CLLotNumber
        CLInMasterShipmentGUID
        CLOutMasterShipmentGUID
        CLWArehouse
        CLGUID
        CLcreatedAt
        CLupdatedAt
        CLmodel
        CLLengthUnit
        CLHeightUnit
        CLWidthUnit
        CLWeightUnit
        CLVolumeUnit
        CLVolumeWeightUnit
        CLLength
        CLHeight
        CLWidth
        CLWeight
        CLVolume
        CLVolumeWeight
        SOclientId
        SONumber
        SOCreatedOn
        SOCreatedByName
        SOVersion
        SOStatus
        SOShippingDate
        SOBuyerName
        SOSellerName
        SOPaymentTerms
        SOExchangeRate
        SOCreatorNetworkID
        SOTotalPieces
        SOTotalAmountInCurrency
        SOIsAcceptedBySeller
        SOIsOnline
        SOIsCancelled
        SOCFstatus_gwae
        SOCFwh_location
        SOCFbrand
        SOCFcommodity_type
        SOGUID
        SOcreatedAt
        SOupdatedAt
        SOBillingClientName
        SOBillingClientGUID
        SOBuyerGUID
        SOSellerGUID
        SOcustomFields {
          name
          value
          internalName
        } 
        }
        CountItems
      }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal,
    }).then((res) => res.json());
    return response.data.GetComodityList;
};

export const cancelFetchCommodity = () => {
    controller.abort(); // Esto cancelará la solicitud
    controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
    signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

function* fetchCommoditySaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchCommodity, data.payload);
        yield put(getCommodityListSuccess(response));
    } catch (error) {
        yield put(getCommodityListFail(error));
    }
}

export const fetchCommodityGUID = async (data: any) => {
    console.log('DATA VERJAN!!! IN fetchCommodityGUID : ', data);

    const currentOBJ = data?.currentGUID?.SelectGuid;
    console.log(currentOBJ);
    const isCL = currentOBJ.hasOwnProperty('CLGUID');
    console.log(isCL);

    let Guid = data.currentGUID.SelectGuid.GUID;
    if (isCL) {
        Guid = currentOBJ.CLGUID;
    }
    const NUMBER = data.currentGUID.SelectGuid.Number;
    let GROUP_NAME = data.groupNameGUID;
    const { groupNameGUID } = data;
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    if (GROUP_NAME === 'POcomparison') {
        GROUP_NAME = 'purchaseOrdersViewList';
    }
    const query = `query {
    GetComodityListByGUID(
      GUID: "${Guid}",
      NUMBER: "${NUMBER}",
      userId: "${user.id}",
      groupName : "${GROUP_NAME}"
      ){
        milestoneConfig {
          OperationType
          OperationName
          userId
          text
          dataField
          visibleInTable
          visibleInModalHeader
          visibleInMiddle
          visibleInModalFooter
          isMilestone          
          visibleInModalBody
          visibleInModalTotal
          showInFilters
          order
          hidden
          data {
            id
            name
          }
        }
        comodityData{
          CRclientId
        CRCreatedOn
        CRReleaseDate
        CRNumber
        CRCreatedByName
        CRVersion
        CRIssuedByName
        CRCreatorNetworkID
        CRTotalPieces
        CRTotalWeight
        CRTotalVolume
        CRTotalVolumeWeight
        CRTotalValue
        CRReleasedToName
        CRStatus
        CRHasAttachments
        CRIsOnline
        CRIsLiquidated
        CRCFaverage_days_to_prepare
        CRCFaverage_days_to_release
        CRCFwh_location
        CRCFcr_cartons
        CRCFcr_pallets
        CRGUID      
        CRBillingClientName
        CRBillingClientGUID
        CRReleasedToGUID
        CRcustomFields {
          name
          value
          internalName
        } 
        PONumber
        POCreatedOn
        POCreatedByName
        POVersion
        POStatus
        POBuyerName
        POSellerName
        POTotalAmountInCurrency
        POItemsAmountInCurrency
        POChargesAmountInCurrency
        POTaxAmountInCurrency
        POTotalAmount
        POItemsAmount
        POChargesAmount
        POTaxAmount
        POTotalWeight
        POTotalVolume
        POTotalTradeDiscount
        POTotalTradeDiscountInCurrency
        POExchangeRate
        POCreatorNetworkID
        POTotalPieces
        POIsAcceptedBySeller
        POIsOnline
        POIsCancelled
        POGUID
        POCFstatus_gwae
        POCFbrand
        POCFcommodity_type
        POcreatedAt
        POupdatedAt
        POBillingClientName
        POBillingClientGUID
        POBuyerGUID
        POSellerGUID
        POcustomFields {
          name
          value
          internalName
        } 
        WRclientId
        WRCreatedOn
        WRNumber
        WRCreatedByName
        WRVersion
        WRModeOfTransportCode
        WRIssuedByName
        WRShipperName
        WRConsigneeName
        WRCreatorNetworkID
        WRTotalPieces
        WRTotalWeight
        WRTotalVolume
        WRTotalVolumeWeight
        WRChargeableWeight
        WRTotalValue
        WRStatus
        WRHasAttachments
        WRLastItemID
        WRIsOnline
        WRIsLiquidated
        WRGUID
        WRCFstatus_gwae
        WRCFwh_location
        WRcreatedAt
        WRupdatedAt
        WRBillingClientName
        WRBillingClientGUID
        WRDestinationAgentName
        WRcustomFields {
          name
          value
          internalName
        } 
        clientId
        CLVersion
        CLStatus
        CLWarehouseReceiptGUID
        CLCargoReleaseGUID
        CLPackageName
        CLLocationCode
        CLWarehouseReceiptNumber
        CLCargoReleaseNumber
        CLOutDate
        CLPieces
        CLPieceQuantity
        CLWHRItemID
        CLOrderIndex
        CLContainedPiecesWeightIncluded
        CLIsContainer
        CLIsSummarized
        CLIncludeInSED
        CLIsPallet
        CLIsOverstock
        CLNotLoaded
        CLInTask
        CLDescription
        CLPartNumber
        CLUpItemGUID
        CLOutShipmentGUID
        CLOutMasterWayBillNumber
        CLOutHouseWayBillNumber
        CLLastReceptionNetworkID
        CLShipmentType
        CLSupplierPONumber
        CLPurchaseOrderGUID
        CLSalesOrderGUID
        CLSOLineID
        CLSalesOrderNumber
        CLEntryDate
        CLExpirationDate
        CLLotNumber
        CLGUID
        CLcreatedAt
        CLupdatedAt
        SOclientId
        SONumber
        SOCreatedOn
        SOCreatedByName
        SOVersion
        SOStatus
        SOShippingDate
        SOBuyerName
        SOSellerName
        SOPaymentTerms
        SOExchangeRate
        SOCreatorNetworkID
        SOTotalPieces
        SOTotalAmountInCurrency
        SOIsAcceptedBySeller
        SOIsOnline
        SOIsCancelled
        SOCFstatus_gwae
        SOCFwh_location
        SOCFbrand
        SOCFcommodity_type
        SOGUID
        SOcreatedAt
        SOupdatedAt
        SOBillingClientName
        SOBillingClientGUID
        SOBuyerGUID
        SOSellerGUID
        SOcustomFields {
          name
          value
          internalName
        } 
        }
      }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    console.log(response.data.GetComodityListByGUID, 'queryyyy');

    return response.data.GetComodityListByGUID;
};




export const fetchPackingList = async (data: any) => {
  const {GUID,groupName} = data;
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  let operation;
  if (getAuthUser) {
      user = JSON.parse(getAuthUser);
  }

  if(groupName){
    operation = groupName == "whareHouseReceiptViewList" ? "WR":"CR"
  }

  const query = `query {
    GetDataPackingList(DataPacking:{
      GUID:"${GUID}",
      Operation:"${operation}",
      userId: ${user.id}
    })
  {
		OperationData {
      clientId
      
      Number
      CreatedOn
      ReleasedToName
    	SupplierPONumber
      
      customFields {
        name
        internalName
        value
      }
    }
    	comodityData{
              customFields{
        name
        internalName
        value
      }
        CLPurchaseOrderGUID
        SkUpc
        CRclientId
        CRCreatedOn
        CRReleaseDate
        CRNumber
        CRCreatedByName
        CRVersion
        CRIssuedByName
        CRTotalPieces
        CRTotalWeight
        CRTotalVolume
        CRTotalVolumeWeight
        CRTotalValue
        CRReleasedToName
        CRStatus
        CRCFwh_location
        CRCFcr_cartons
        CRCFcr_pallets
        CRGUID      
        CRReleasedToGUID

        CLHeight
        CLWidth
        CLLength
        CLWeight
        CLVolume

        clientId
        CLVersion
        CLStatus
        CLWarehouseReceiptGUID
        CLCargoReleaseGUID
        CLPackageName
        CLCargoReleaseNumber
        CLOutDate
        CLPieces
        CLPieceQuantity
        CLWHRItemID
        CLOrderIndex
        CLContainedPiecesWeightIncluded
        CLIsContainer
        CLIsSummarized
        CLIncludeInSED
        CLIsPallet
        CLIsOverstock
        CLNotLoaded
        CLInTask
        CLDescription
        CLPartNumber
        CLUpItemGUID
        CLShipmentType
        CLSupplierPONumber
        CLEntryDate
        CLExpirationDate
        CLLotNumber
        CLGUID
        CLcreatedAt
        CLupdatedAt
        CLPalletID
        }
    	message
  }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        query,
    }),
}).then((res) => res.json());

  return response.data.GetDataPackingList;
};











function* fetchCommodityByGuidSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchCommodityGUID, data.payload);
        yield put(getCommodityListByGUIDSuccess(response));
    } catch (error) {
        yield put(getCommodityListByGUIDFail(error));
    }
}

function* getMilestoneConfigCommodity(data: any): any {
    try {
        const response: Promise<any> = yield call(getMilestoneConfigOperation, 'WI');
        yield put(getMilestoneConfigCommoditySuccess(response));
    } catch (error) {
        yield put(getMilestoneConfigCommodityFail(error));
    }
}

function* getPackingListCommodity(data: any): any {
  try {
      const response: Promise<any> = yield call(fetchPackingList, data.payload);
      yield put(getPackingListCommoditySuccess(response));
  } catch (error) {
      yield put(getPackingListCommodityFail(error));
  }
}

function* CommoditySaga() {
    yield takeLatest(commodityTypes.GET_COMMODITY_DEFINITIONS, fetchCommoditySaga);
    yield takeLatest(commodityTypes.GET_COMMODITY_BY_GUID_DEFINITIONS, fetchCommodityByGuidSaga);
    yield takeLatest(commodityTypes.GET_MILESTONESCONFIG_COMMODITY, getMilestoneConfigCommodity);
    yield takeLatest(commodityTypes.GET_PACKINGLIST_COMMODITY, getPackingListCommodity);
}

export default CommoditySaga;
